const hasOwn = (obj, key) => Object.prototype.hasOwnProperty.call(obj, key)

export default {
  isVNode (node) {
    return typeof node === 'object' && hasOwn(node, 'componentOptions')
  }
}
